<div class="comments-filter">
  @if (commentsFilterValue$() !== null) {
    <mat-toolbar class="comments-filter__toolbar">
      <div class="comments-filter__toolbar-filters">
        <button mat-stroked-button [class.active]="filterControl.value" (click)="onApplyFilter()">
          {{ commentsFilterValue$() | uppercase }}
        </button>
        <button mat-stroked-button [class.active]="!filterControl.value" (click)="onShowAll()">
          Show all
        </button>
      </div>
    </mat-toolbar>

    @if(allowFilterRemoval) {
      <button mat-icon-button title="Remove filter" class="comments-filter__remove" (click)="removeFilter.emit()">
        <fa-icon [icon]="faClose"></fa-icon>
      </button>
    }
  }

</div>
